import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { keycloak } from "../providers/AuthProvider";

const { REACT_APP_SERVER_URL } = process.env;

const rawBaseQuery = fetchBaseQuery({
  baseUrl: REACT_APP_SERVER_URL,
  prepareHeaders: (headers) => {
    if (keycloak && keycloak.token) {
      headers.set("Authorization", `Bearer ${keycloak.token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  // Refresh (if expiring within 30s) before every request
  if (keycloak && typeof keycloak.updateToken === "function") {
    try {
      await keycloak.updateToken(30);
    } catch (err) {
      return {
        error: {
          status: 401,
          data: { message: "Session expired (unable to refresh token)." },
        },
      };
    }
  }

  let result = await rawBaseQuery(args, api, extraOptions);

  // If still unauthorized, try one forced refresh + retry once
  if (result.error && result.error.status === 401) {
    try {
      if (keycloak && typeof keycloak.updateToken === "function") {
        await keycloak.updateToken(0);
      }
      result = await rawBaseQuery(args, api, extraOptions);
    } catch (err) {
      // Optional: keycloak.login();
    }
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Cv", "User"],
  endpoints: (builder) => ({}),
});
